module.exports = __webpack_public_path__ + "img/item3.540efd0e.png";